export enum TEXT_COLOR {
    SUCCESS = 'success',
    DANGER = 'danger',
    GRAY = 'gray',
    PRIMARY = 'primary',
    INFO = 'info',
}

export type TextColor = `${TEXT_COLOR}`;
